<template>
  <v-card-text>
    <v-row>
      <v-col cols="12">
        <exo-simu-display-strategies-card
          v-if="
            missionManager
              .dashboardTools()
              .isManeuveringStrategyDesignMission(results)
          "
          :missionManager="missionManager"
          :results="results"
          :path="[]"
        />
      </v-col>
    </v-row>
    <v-row class="d-flex">
      <v-col cols="4">
        <exo-simu-display-orbit-maneuver
          :additionalData="additionalData"
          :missionManager="missionManager"
          :results="results"
          label="Mission"
          :path="['maneuverReport']"
          :colorIndex="0"
          :expand="true"
        />
        <exo-simu-display-spacecraft-thruster
          :additionalData="additionalData"
          :missionManager="missionManager"
          :results="results"
          label="Propulsion system"
          :path="['spacecraft', 'thruster']"
          :colorIndex="1"
        />
        <exo-simu-display-spacecraft-battery
          :additionalData="additionalData"
          :missionManager="missionManager"
          :results="results"
          label="Battery"
          :path="['spacecraft', 'batteryDefinition']"
          :colorIndex="2"
        />
        <exo-simu-display-spacecraft-payload
          :additionalData="additionalData"
          :missionManager="missionManager"
          :results="results"
          label="Payload"
          :path="['spacecraft', 'payload']"
          :colorIndex="3"
        />
        <exo-simu-display-spacecraft-antenna
          :additionalData="additionalData"
          :missionManager="missionManager"
          :results="results"
          label="Antenna"
          :path="['spacecraft', 'antennaDefinition']"
          :colorIndex="4"
        />
        <exo-simu-display-spacecraft-reactionWheel
          :additionalData="additionalData"
          :missionManager="missionManager"
          :results="results"
          label="Reaction Wheel"
          :path="['spacecraft', 'reactionWheelDefinition']"
          :colorIndex="5"
        />
      </v-col>
      <v-col cols="4">
        <exo-simu-display-spacecraft
          :additionalData="additionalData"
          :missionManager="missionManager"
          :results="results"
          label="Spacecraft"
          :path="['spacecraft']"
          :colorIndex="4"
          :expand="true"
        />
        <exo-simu-display-spacecraft-geometry
          :additionalData="additionalData"
          :missionManager="missionManager"
          :results="results"
          label="Spacecraft geometry"
          :path="['spacecraft', 'spacecraftGeometry']"
          :colorIndex="6"
        />
        <exo-simu-display-manoeuvring-strategy
          :additionalData="additionalData"
          :missionManager="missionManager"
          v-if="
            !missionManager
              .dashboardTools()
              .isManeuveringStrategyDesignMission(results)
          "
          :results="results"
          label="Manoeuvring strategy"
          :path="['maneuveringStrategy']"
          :colorIndex="7"
        />
      </v-col>
      <v-col cols="4">
        <exo-simu-display-orbit
          :additionalData="additionalData"
          :missionManager="missionManager"
          :results="results"
          label="Initial orbit"
          :path="['initialOrbit']"
          :colorIndex="8"
          :expand="true"
        />
        <exo-simu-display-orbit
          :additionalData="additionalData"
          :missionManager="missionManager"
          :results="results"
          label="Final orbit"
          :path="['finalOrbit']"
          :colorIndex="9"
        />
        <exo-simu-display-ephemerides
          :additionalData="additionalData"
          :missionManager="missionManager"
          :results="results"
          label="Ephemerides"
          :path="['']"
          :colorIndex="10"
        />
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
/* eslint-disable vue/no-dupe-keys */
import dataTools from '../../tools/data.js'
import Vue from 'vue'
import dataDescription from '../../tools/dataDescription.json'
import tooltipNumericalDutyCycles from '../../components/Tooltips/tooltipNumericalDutyCycles'
import { mapGetters } from 'vuex'

let displayObjectCommon = {
  props: {
    missionManager: Object,
    results: Object,
    label: String,
    path: Array,
    colorIndex: Number,
    expand: {
      type: Boolean,
      default: false
    },
    additionalData: {
      type: Object,
      default: null
    }
  },

  computed: {
    isCompareMode() {
      return this.additionalData?.results != null
    },

    ephemeridesToShow() {
      let ephemeridesToShow = []
      if (!this.results || !this.results.fieldIndexes) {
        return ephemeridesToShow
      }
      let keys = Object.keys(this.ephemerides)
      for (let key of keys) {
        let typesInIndexes = this.ephemerides[key].types.filter(
          (type) => this.results.fieldIndexes[type] != null
        )
        if (typesInIndexes.length > 0) {
          ephemeridesToShow.push({
            label: this.ephemerides[key].label,
            types: typesInIndexes
          })
        }
      }
      return ephemeridesToShow
    }
  },

  methods: {
    displayValue(value, field) {
      let type = dataTools.getFieldTypeFromPath(field, this.context, null)
      if (type === 'string') {
        return value
      }
      if (type === 'vector' || type === 'matrix') {
        let fieldDescription = dataTools.getResultFieldFromPath(
          field,
          this.context
        )
        for (let i = 0; i < value.length; i++) {
          value[i] = this.getSignificantNumber(
            dataTools.convertSi2Display(
              fieldDescription.dimensions[0].type,
              value[i]
            ),
            3
          )
        }
        return (
          '[' +
          value +
          ']' +
          this.getUnitSuffix(fieldDescription.dimensions[0], value)
        )
      }
      if (value == null || isNaN(value) || value === 'NaN') {
        return 'undefined'
      } else {
        value = this.getSignificantNumber(
          dataTools.convertSi2Display(type, value),
          3
        )
      }
      return value + this.getUnitSuffix(field, value)
    },

    getUnitSuffix(field, value) {
      if (value !== '' && value !== 'undefined') {
        let fieldType = dataTools.getFieldTypeFromPath(
          field,
          this.context,
          null
        )
        return (
          ' ' +
          dataTools.getUnitDisplayed(dataTools.getDefaultGuiUnit(fieldType))
        )
      }
      return ''
    },

    getDisplayedString(results, field, maxLength) {
      let value = results
      if (value == null) {
        return ''
      }
      for (let i = 0; i < field.length; i++) {
        if (value == null) {
          return ''
        }
        value = value[field[i]]
      }
      if (value == null) {
        return ''
      }
      return value.length > maxLength
        ? value.toString().slice(0, maxLength) + '...'
        : value
    },

    getFieldValue(field) {
      let value = this.buildResultFieldValue(this.results, field)
      if (this.isCompareMode) {
        value =
          value +
          ' <> ' +
          this.buildResultFieldValue(this.additionalData.results, field)
      }
      return value + this.getUnitSuffix(field, value)
    },

    buildResultFieldValue(results, field) {
      let type = dataTools.getFieldTypeFromPath(field, this.context, null)
      if (type === 'matrix') {
        return this.getDisplayedMatrixValue(results, this.path, field)
      } else if (type === 'vector') {
        return this.getDisplayedVectorValue(results, this.path, field, true)
      } else if (
        dataDescription[type] != null &&
        (dataDescription[type].type === 'int' ||
          dataDescription[type].type === 'double' ||
          dataDescription[type].type === 'integer')
      ) {
        return this.getDisplayedValueWithoutUnit(results, field)
      } else {
        let maxLength = this.isCompareMode ? 20 : 40
        return this.getDisplayedString(results, field, maxLength)
      }
    },

    getDisplayedVectorValue(results, path, field, isUnit) {
      let vector = '['
      let fieldDescription = dataTools.getResultFieldFromPath(
        field,
        this.context
      )
      for (let dimension of fieldDescription.dimensions) {
        vector += this.getDisplayedValueWithoutUnit(
          results,
          path.concat(dimension)
        )
        vector += ', '
      }
      vector = vector.substring(0, vector.length - 2)
      vector += ']'
      if (isUnit) {
        return vector + this.getArrayUnitSuffix(results, path, field)
      } else {
        return vector
      }
    },

    getArrayUnitSuffix(results, path, field) {
      let fieldDescription = dataTools.getResultFieldFromPath(
        field,
        this.context
      )
      let firstValue = fieldDescription.dimensions[0]
      return this.getUnitSuffix(
        firstValue,
        this.getDisplayedValueWithoutUnit(results, path.concat(firstValue))
      )
    },

    getDisplayedMatrixValue(results, path, field) {
      let matrix = '['
      let fieldDescription = dataTools.getResultFieldFromPath(
        field,
        this.context
      )
      for (let dimension of fieldDescription.dimensions) {
        matrix += this.getDisplayedVectorValue(
          results,
          path,
          path.concat(dimension),
          false
        )
        matrix += ', \n'
      }
      matrix = matrix.substring(0, matrix.length - 2)
      matrix += ']'
      return (
        matrix +
        this.getArrayUnitSuffix(
          this.results,
          path,
          path.concat(fieldDescription.dimensions[0])
        )
      )
    },

    getFieldLabel(field) {
      return dataTools.getFieldLabelFromPath(field, this.context)
    },

    getSignificantNumber(value, precision) {
      if (
        dataTools.isNumber(value) &&
        value.toString().length > precision + 2
      ) {
        return parseFloat(value).toFixed(
          Math.min(precision, value.toString().length - 2)
        )
      } else {
        return value
      }
    },

    getDisplayedValueWithoutUnit(results, field) {
      let value = results
      if (results == null) {
        return ''
      }
      let type = dataTools.getFieldTypeFromPath(field, this.context, null)
      for (let i = 0; i < field.length; i++) {
        value = value[field[i]]
        if (value == null) {
          return 'undefined'
        }
      }
      if (value == null || isNaN(value) || value === 'NaN') {
        return 'undefined'
      } else {
        value = this.getSignificantNumber(
          dataTools.convertSi2Display(type, value),
          3
        )
      }
      return value
    },

    getColor(index) {
      return this.getCardColors()[index]
    },
    getCardColors() {
      return [
        '#ff948c',
        '#ffb58c',
        '#ffd18c',
        '#8cffff',
        '#8ce7ff',
        '#8cceff',
        '#938cff',
        '#c78cff',
        '#ff8ca8',
        '#ff8c8c',
        '#a5ffd9'
      ]
    },

    displayData(field) {
      return !this.getFieldValue(field).toString().includes('undefined')
    },

    existingObject(object) {
      return object !== undefined && object !== null
    }
  },

  data() {
    return {
      ephemeridesShown: ['eclipse'],
      ephemerides: {
        missionEphemerides: {
          label: 'Mission',
          types: [
            'relativeRaan',
            'relativeArgumentOfLatitude',
            'relativeECIPosX',
            'relativeECIPosY',
            'relativeECIPosZ',
            'relativeECIVelX',
            'relativeECIVelY',
            'relativeECIVelZ'
          ]
        },
        perturbationsEphemerides: {
          label: 'Perturbations',
          types: ['pertubationsDragDensity']
        },
        keplerianEphemerides: {
          label: 'Keplerian',
          types: [
            'keplerianSma',
            'keplerianAltitude',
            'keplerianEcc',
            'keplerianInc',
            'keplerianPa',
            'keplerianRaan',
            'keplerianLtan'
          ]
        },
        keplerianMeanEphemerides: {
          label: 'Keplerian Mean',
          types: [
            'keplerianMeanSma',
            'keplerianMeanAltitude',
            'keplerianMeanEcc',
            'keplerianMeanInc',
            'keplerianMeanPa',
            'keplerianMeanRaan',
            'keplerianMeanLtan'
          ]
        },
        equinoctialEphemerides: {
          label: 'Equinoctial',
          types: [
            'equinoctialSma',
            'equinoctialEx',
            'equinoctialEy',
            'equinoctialHx',
            'equinoctialHy',
            'equinoctialMeanLongitude',
            'equinoctialTrueLongitude'
          ]
        },
        equinoctialMeanEphemerides: {
          label: 'Equinoctial Mean',
          types: [
            'equinoctialMeanSma',
            'equinoctialMeanEx',
            'equinoctialMeanEy',
            'equinoctialMeanHx',
            'equinoctialMeanHy',
            'equinoctialMeanMeanLongitude',
            'equinoctialMeanTrueLongitude'
          ]
        },
        circularEphemerides: {
          label: 'Circular',
          types: [
            'circularSma',
            'circularEx',
            'circularEy',
            'circularInc',
            'circularRaan'
          ]
        },
        circularMeanEphemerides: {
          label: 'Circular Mean',
          types: [
            'circularMeanSma',
            'circularMeanEx',
            'circularMeanEy',
            'circularMeanInc',
            'circularMeanRaan'
          ]
        },
        cartesianEphemerides: {
          label: 'Cartesian',
          types: [
            'cartesianX',
            'cartesianY',
            'cartesianZ',
            'cartesianVx',
            'cartesianVy',
            'cartesianVz'
          ]
        },
        cartesianMeanEphemerides: {
          label: 'Cartesian Mean',
          types: [
            'cartesianMeanX',
            'cartesianMeanY',
            'cartesianMeanZ',
            'cartesianMeanVx',
            'cartesianMeanVy',
            'cartesianMeanVz'
          ]
        },
        thrustEphemerides: {
          label: 'Thrust',
          types: ['thrustDirectionAlpha', 'thrustDirectionDelta']
        },
        systemEphemerides: {
          label: 'System',
          types: [
            'batteryState',
            'currentMass',
            'instantConsumption',
            'totalConsumption',
            'remainingPropellant'
          ]
        },
        eclipseEphemerides: {
          label: 'Eclipse',
          types: ['eclipse']
        },
        attitudeEphemerides: {
          label: 'Attitude',
          types: ['attitudeX', 'attitudeY', 'attitudeZ']
        },
        manoeuvringStrategiesEphemerides: {
          label: 'Manoeuvring Strategies',
          types: ['dynamicDutyCycle']
        }
      },
      context: 'SimulationResult'
    }
  }
}

Vue.component('exo-simu-display-field', {
  mixins: [displayObjectCommon],

  props: ['field', 'path'],

  template: `
    <v-list-item v-if="this.displayData(path.concat(field))">
        <v-row no-gutters>
          <v-col cols="6">
            <v-row no-gutters>
              <v-col>
                <v-list-item-content>{{ getFieldLabel(path.concat(field)) }}</v-list-item-content>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1">
            <v-divider vertical></v-divider>
          </v-col>
          <v-col cols="5">
            <v-row no-gutters>
              <v-col>
                <v-list-item-content class="justify-end text-right">{{ getFieldValue(path.concat(field)) }}</v-list-item-content>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-list-item>
  `
})

Vue.component('exo-simu-display-object', {
  mixins: [displayObjectCommon],

  props: ['field', 'value'],

  template: `
    <v-list-item>
        <v-row no-gutters>
          <v-col cols="6">
            <v-row no-gutters>
              <v-col>
                <v-list-item-content>{{ getFieldLabel(field) }}</v-list-item-content>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1">
            <v-divider vertical></v-divider>
          </v-col>
          <v-col cols="5">
            <v-row no-gutters>
              <v-col>
                <v-list-item-content class="justify-end text-right">{{ displayValue(value,field) }}</v-list-item-content>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-list-item>
  `
})

Vue.component('exo-simu-display-card', {
  mixins: [displayObjectCommon],

  props: ['label', 'colorIndex', 'expand'],

  data() {
    return {
      expandPanel: this.expand
    }
  },

  template: `
  <v-col m-2>
    <v-card height="100%">
      <div v-bind:style="{ 'background-color': getColor(colorIndex)}"  style="height: 10px"></div>
      <v-card-title :class="$vuetify.theme.dark ? '' : 'black--text'">
        <h5>{{ label }}</h5>
        <v-spacer></v-spacer>
        <v-col cols="1">
          <slot name="helpDialog"></slot>
        </v-col>
        <v-btn icon v-on:click="expandPanel = !expandPanel">
          <v-icon color="grey darken-1" v-if="expandPanel">expand_less</v-icon>
          <v-icon color="grey darken-1" v-if="!expandPanel">expand_more</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="m-0" v-if="expandPanel"></v-divider>
      <v-list v-if="expandPanel" dense class="p-0">
         <slot></slot>
      </v-list>
    </v-card>
  </v-col>
  `
  // TODO MFI on click copy content to clipboard
})

Vue.component('exo-simu-display-orbit', {
  mixins: [displayObjectCommon],

  data() {
    return { type: 'orbit' }
  },

  template: `
  <exo-simu-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['type']"/>
      <exo-simu-display-field :additionalData="additionalData" v-if="isElliptical()" :missionManager="missionManager" :results="results" :path="path" :field="['perigeeAltitude']"/>
      <exo-simu-display-field :additionalData="additionalData" v-if="isElliptical()" :missionManager="missionManager" :results="results" :path="path" :field="['apogeeAltitude']"/>
      <exo-simu-display-field :additionalData="additionalData" v-if="!isElliptical()" :missionManager="missionManager" :results="results" :path="path" :field="['altitude']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['semiMajorAxis']"/>
      <exo-simu-display-field :additionalData="additionalData" v-if="isElliptical()" :missionManager="missionManager" :results="results" :path="path" :field="['eccentricity']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['sunSynchronousOrbit']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['inclination']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['keplerianPeriod']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['meanNodalPeriod']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['raan']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['ltan']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['perigeeArgument']"/>
      <exo-simu-display-field :additionalData="additionalData" v-if="missionManager.dashboardTools().isRAANMission(results)" :missionManager="missionManager" :results="results" :path="path" :field="['raanDriftRate']"/>
      <exo-simu-display-field :additionalData="additionalData" v-if="missionManager.dashboardTools().isRAANMission(results)" :missionManager="missionManager" :results="results" :path="path" :field="['ltanDriftRate']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['meanMotion']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['velocity']"/>
  </exo-simu-display-card>
  `,

  methods: {
    isElliptical() {
      return (
        this.results &&
        this.results[this.path[0]] &&
        this.results[this.path[0]].type === 'Elliptical'
      )
    }
  }
})

Vue.component('exo-simu-display-spacecraft', {
  mixins: [displayObjectCommon],

  data() {
    return { type: 'spacecraft' }
  },

  template: `
  <exo-simu-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['platformMass']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['onBoardAveragePower']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['platformPower']"/>
  </exo-simu-display-card>
  `
})

Vue.component('exo-simu-display-spacecraft-payload', {
  mixins: [displayObjectCommon],

  mounted() {
    this.getPayloadObject()
  },

  computed: {
    ...mapGetters({ currentResultsLog: 'currentResultsLog' })
  },

  data() {
    return {
      type: 'payload',
      payloadObject: null
    }
  },

  methods: {
    getPayloadObject() {
      this.payloadObject = this.currentResultsLog.results.spacecraft.payload
    }
  },

  template: `
  <exo-simu-display-card v-if="this.existingObject(this.payloadObject)" :label="label" :colorIndex="colorIndex" :expand="expand">
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['payloadPower']"/>
  </exo-simu-display-card>
  `
})

Vue.component('exo-simu-display-spacecraft-battery', {
  mixins: [displayObjectCommon],

  mounted() {
    this.getBatteryObject()
  },

  computed: {
    ...mapGetters({ currentResultsLog: 'currentResultsLog' })
  },

  data() {
    return {
      type: 'batteryDefinition',
      batteryObject: null
    }
  },

  methods: {
    getBatteryObject() {
      this.batteryObject =
        this.currentResultsLog.results.spacecraft.batteryDefinition
    }
  },

  template: `
  <exo-simu-display-card v-if="this.existingObject(this.batteryObject)" :label="label" :colorIndex="colorIndex" :expand="expand">
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['depthOfDischarge']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['minimumChargeForFiring']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['nominalCapacity']"/>
      <exo-simu-display-field :additionalData="additionalData" v-if="!missionManager.dashboardTools().isOrbitExtrapolationMission(results)" :missionManager="missionManager" :results="results" :path="path" :field="['finalCharge']"/>
  </exo-simu-display-card>
  `
})

Vue.component('exo-simu-display-spacecraft-reactionWheel', {
  mixins: [displayObjectCommon],

  mounted() {
    this.getReactionWheelObject()
  },

  computed: {
    ...mapGetters({ currentResultsLog: 'currentResultsLog' })
  },

  data() {
    return {
      type: 'reactionWheelDefinition',
      reactionWheelObject: null
    }
  },

  methods: {
    getReactionWheelObject() {
      this.reactionWheelObject =
        this.currentResultsLog.results.spacecraft.reactionWheels
    }
  },

  template: `
  <exo-simu-display-card v-if="this.existingObject(this.reactionWheelObject) && this.reactionWheelObject.length > 0" :label="label" :colorIndex="colorIndex" :expand="expand">
    <v-expansion-panels>
        <v-expansion-panel
          v-for="reactionWheel in this.reactionWheelObject"
          :key="reactionWheel.id"
        >
          <v-expansion-panel-header>
            <div>{{reactionWheel.name}}</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-0">
            <exo-simu-display-object :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :value="reactionWheel.name" :field="['spacecraft','reactionWheelDefinition','name']"/>
            <exo-simu-display-object :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :value="reactionWheel.positionInSpacecraftFrame" :field="['spacecraft','reactionWheelDefinition','positionInSpacecraftFrame']"/>
            <exo-simu-display-object :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :value="reactionWheel.directionInSpacecraftFrame" :field="['spacecraft','reactionWheelDefinition','directionInSpacecraftFrame']"/>
            <exo-simu-display-object :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :value="reactionWheel.maxTorque" :field="['spacecraft','reactionWheelDefinition','maxTorque']"/>
            <exo-simu-display-object :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :value="reactionWheel.maxAngularMomentum" :field="['spacecraft','reactionWheelDefinition','maxAngularMomentum']"/>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
   </exo-simu-display-card>
  `
})

Vue.component('exo-simu-display-spacecraft-antenna', {
  mixins: [displayObjectCommon],

  mounted() {
    this.getAntennaObject()
  },

  computed: {
    ...mapGetters({ currentResultsLog: 'currentResultsLog' })
  },

  data() {
    return {
      type: 'antennaDefinition',
      antennaObject: null
    }
  },

  methods: {
    getAntennaObject() {
      this.antennaObject =
        this.currentResultsLog.results.spacecraft.antennaDefinition
    }
  },

  template: `
  <exo-simu-display-card v-if="this.existingObject(this.antennaObject)" :label="label" :colorIndex="colorIndex" :expand="expand">
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['antennaPower']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['upLinkRate']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['downLinkRate']"/>
  </exo-simu-display-card>
  `
})

Vue.component('exo-simu-display-spacecraft-geometry', {
  mixins: [displayObjectCommon],

  data() {
    return { type: 'spacecraftGeometry' }
  },

  computed: {
    getGeometry() {
      return dataTools.getFieldValueFromPath(this.path, this.results)
    },

    isBoxShape() {
      if (this.getGeometry != null) {
        return this.getGeometry['type'] === 'Box'
      } else {
        return false
      }
    },

    getSolarArrayType() {
      if (this.isBoxShape) {
        return this.getGeometry['solarArrayType']
      } else {
        return ''
      }
    },

    isSolarArrayBodyType() {
      return this.getSolarArrayType === 'SolarArrayTypeBody'
    },

    isSolarArrayDeployableType() {
      return (
        this.isSolarArrayDeployableRotatingType ||
        this.isSolarArrayDeployableFixedType
      )
    },

    isSolarArrayDeployableRotatingType() {
      return this.getSolarArrayType === 'SolarArrayTypeDeployableRotating'
    },

    isSolarArrayDeployableFixedType() {
      return this.getSolarArrayType === 'SolarArrayTypeDeployableFixed'
    }
  },

  template: `
  <exo-simu-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['type']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="!isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['sphericalCrossSection']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['x']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['y']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['z']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['thrusterAxisInSatelliteFrame']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['payloadPointingAxisInSatelliteFrame']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['antennaPointingAxisInSatelliteFrame']"/>

    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['surfaceX']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['surfaceY']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['surfaceZ']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['totalSurface']"/>

    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['inertialCenterInSpacecraftFrame']"/>

    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['inertialMatrix']"/>

    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayType']"/>

    <exo-simu-display-field :additionalData="additionalData" v-if="isBoxShape" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayEfficiency']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayDeployableType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayMaximumPower']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayDeployableType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayTotalSurface']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayDeployableType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayAxisInSatelliteFrame']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayDeployableFixedType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayNormalInSatelliteFrame']"/>

    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayBodyType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayPlusXsurface']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayBodyType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayPlusYsurface']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayBodyType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayPlusZsurface']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayBodyType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayMinusXsurface']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayBodyType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayMinusYsurface']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayBodyType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayMinusZsurface']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayBodyType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayTotalSurface']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayBodyType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayMaxPowerXsurface']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayBodyType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayMaxPowerYsurface']"/>
    <exo-simu-display-field :additionalData="additionalData" v-if="isSolarArrayBodyType" :missionManager="missionManager" :results="results" :path="path" :field="['solarArrayMaxPowerZsurface']"/>
  </exo-simu-display-card>
  `
})

Vue.component('exo-simu-display-manoeuvring-strategy', {
  mixins: [displayObjectCommon],

  components: {
    tooltipNumericalDutyCycles
  },

  data() {
    return {
      type: 'maneuveringStrategy'
      // tooltipImgPath: require('../../assets/images/tooltip-costs.png')
    }
  },

  template: `
  <exo-simu-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
      <template v-slot:helpDialog>
        <tooltipNumericalDutyCycles/>
      </template>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['thrustArcsNumber']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['thrustArcsPosition']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['reference']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['deltaMeanLongitudeArgument']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['numberOfThrustOrbits']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['numberOfRestOrbits']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['numberOfShiftOrbits']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['stopThrustInEclipse']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['dynamicDutyCycleSimulated']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['spacecraftDefinitionDutyCycle']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['warmupMeanDutyCycle']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['orbitalDutyCycle']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['maxMeanDutyCycle']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['thrustArcDuration']"/>
  </exo-simu-display-card>
  `
})

Vue.component('exo-simu-display-spacecraft-thruster', {
  mixins: [displayObjectCommon],

  data() {
    return { type: 'thruster' }
  },

  computed: {
    
    ...mapGetters({ currentResultsLog: 'currentResultsLog' }),

    isElectricalThruster() {
      return this.currentResultsLog.results.spacecraft.thruster.propulsionSystemType === "ELECTRICAL"
    },

    isChemicalThruster() {
      return this.currentResultsLog.results.spacecraft.thruster.propulsionSystemType === "CHEMICAL"
    }
  },

  template: `
  <exo-simu-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-simu-display-field :additionalData="additionalData" v-if="isElectricalThruster" :missionManager="missionManager" :results="results" :path="path" :field="['electricalEfficiency']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['power']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['thrust']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['isp']"/>
      <exo-simu-display-field :additionalData="additionalData" v-if="isElectricalThruster" :missionManager="missionManager" :results="results" :path="path" :field="['standbyPower']"/>
      <exo-simu-display-field :additionalData="additionalData" v-if="isChemicalThruster" :missionManager="missionManager" :results="results" :path="path" :field="['thrustDuration']"/>
      <exo-simu-display-field :additionalData="additionalData" v-if="isElectricalThruster" :missionManager="missionManager" :results="results" :path="path" :field="['warmUpDuration']"/>
      <exo-simu-display-field :additionalData="additionalData" v-if="isElectricalThruster" :missionManager="missionManager" :results="results" :path="path" :field="['warmUpPower']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['initialTotalMass']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['totalMass']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['totalImpulse']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['initPropellantMass']"/>
      <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['finalPropellantMass']"/>
  </exo-simu-display-card>
  `
})

Vue.component('exo-simu-display-ephemerides', {
  mixins: [displayObjectCommon],

  data() {
    return { type: 'ephemerides' }
  },

  template: `
    <exo-simu-display-card :label="label" :colorIndex="colorIndex" v-if="ephemeridesToShow.length > 0" >
      <v-expansion-panels>
        <v-expansion-panel
          v-for="ephemeridesType in ephemeridesToShow"
          :key="ephemeridesType.label"
        >
          <v-expansion-panel-header>
            <div>{{ephemeridesType.label}}</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-0">
            <v-list-item class="pa-0 ma-0" v-for="item in ephemeridesType.types" :key="item">
             <v-row no-gutters>
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col>
                    <v-list-item-content>{{ formatToHuman(item) }}</v-list-item-content>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="1">
                <v-divider style="align-self: auto" vertical></v-divider>
              </v-col>
              <v-col cols="5">
                <v-row no-gutters>
                  <v-col>
                    <v-list-item-content class="justify-end text-right">{{ getDisplayedEphemeridesValueWithUnit(item) }}</v-list-item-content>
                  </v-col>
                </v-row>
              </v-col>
              </v-row>
            </v-list-item>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </exo-simu-display-card>
  `,

  methods: {
    formatToHuman(field) {
      return dataTools.getFieldLabelFromPath([field], this.context)
    },

    isFieldInEphemerides(results, field) {
      if (results?.fieldIndexes?.[field] == null) {
        return false
      }
      return true
    },

    buildDisplayedEphemeridesValueSingleResult(results, field) {
      if (!this.isFieldInEphemerides(results, field)) {
        return 'undefined'
      }
      let data = dataTools
        .convertSimulationData(results.ephemerides, results.fieldIndexes)
        .map((el) => el[field])
      let fieldType = dataTools.getFieldTypeFromPath(
        [field],
        this.context,
        null
      )
      let min = dataTools.convertSi2Display(fieldType, Math.min(...data))
      if (min === '') {
        return 'undefined'
      }
      let max = dataTools.convertSi2Display(fieldType, Math.max(...data))
      let value = ''
      if (min === max) {
        value = min
      } else {
        value = '[' + min + ' ... ' + max + '] '
      }
      return value
    },

    getDisplayedEphemeridesValueWithUnit(field) {
      let value = this.buildDisplayedEphemeridesValueSingleResult(
        this.results,
        field
      )
      if (this.isCompareMode) {
        value =
          value +
          ' <> ' +
          this.buildDisplayedEphemeridesValueSingleResult(
            this.additionalData.results,
            field
          )
      }
      return value + this.getUnitSuffix(field, value)
    }
  }
})

Vue.component('exo-simu-display-orbit-maneuver', {
  mixins: [displayObjectCommon],
  props: {
    isSubMission: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { type: 'maneuver' }
  },

  methods: {
    buildDate(results) {
      let a = new Date(Date.parse(results['missionDateTime']))
      let months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]
      let year = a.getFullYear()
      let month = months[a.getMonth()]
      let date = a.getDate()
      let hour = a.getHours()
      let min = a.getMinutes()
      let sec = a.getSeconds()
      let time =
        year + ' ' + month + ' ' + date + ' - ' + hour + ':' + min + ':' + sec
      return time
    },

    getDate() {
      let value = this.buildDate(this.results)
      if (this.isCompareMode) {
        value = value + ' <> ' + this.buildDate(this.additionalData.results)
      }
      return value
    }
  },

  template: `
  <exo-simu-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
    <v-row no-gutters class="1">
      <v-col cols="6">
        <v-row no-gutters>
          <v-col>
            <v-list-item-content class="ml-4">Date</v-list-item-content>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1">
        <v-divider vertical></v-divider>
      </v-col>
      <v-col cols="5">
        <v-row no-gutters>
          <v-col>
            <v-list-item-content class="justify-end mr-4">{{ getDate() }}</v-list-item-content>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    </v-list-item>
    <exo-simu-display-mission-summary-fields :additionalData="additionalData" v-if="!missionManager.dashboardTools().isOrbitExtrapolationMission(results) && !missionManager.dashboardTools().isManeuveringStrategyDesignMission(results)" :missionManager="missionManager" :results="results" :path="path"/>
    <exo-simu-display-positioning-maneuver :additionalData="additionalData" v-if="missionManager.dashboardTools().isPositioningMission(results)" :missionManager="missionManager" :results="results" :path="[]"/>
    <exo-simu-display-orbitextrapolation-maneuver :additionalData="additionalData" v-if="missionManager.dashboardTools().isOrbitExtrapolationMission(results)" :missionManager="missionManager" :results="results" :path="[]"/>
    <exo-simu-display-SpacecraftDesignAnalysis-maneuver :additionalData="additionalData" v-if="missionManager.dashboardTools().isManeuveringStrategyDesignMission(results)" :missionManager="missionManager" :results="results" :path="[]"/>
    <exo-simu-display-raan-maneuver :additionalData="additionalData" v-if="missionManager.dashboardTools().isRAANMission(results)" :missionManager="missionManager" :results="results" :path="[]"/>
    <exo-simu-display-aolphasing-maneuver :additionalData="additionalData" v-if="missionManager.dashboardTools().isArgumentOfLatitudePhasingMission(results)" :missionManager="missionManager" :results="results" :path="[]"/>
    <exo-simu-display-leostationkeeping-maneuver :additionalData="additionalData" v-if="missionManager.dashboardTools().isStationKeepingLEOMission(results)" :missionManager="missionManager" :results="results" :path="[]"/>

  </exo-simu-display-card>
    `
})

Vue.component('exo-simu-display-positioning-maneuver', {
  mixins: [displayObjectCommon],
  props: {
    isSubMission: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { type: 'positioning' }
  },

  template: `
  <div>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['maximumDuration']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['deltaSemiMajorAxis']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['deltaEccentricity']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['deltaInclination']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['perturbations']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['attitudeAndSystemSimulated']"/>
  </div>
   `
})

Vue.component('exo-simu-display-orbitextrapolation-maneuver', {
  mixins: [displayObjectCommon],
  props: {
    isSubMission: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { type: 'orbitextrapolation' }
  },

  template: `
  <div>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['simulationDuration']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['perturbations']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['deltaSemiMajorAxis']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['deltaInclination']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['deltaRaan']"/>
  </div>
   `
})

Vue.component('exo-simu-display-leostationkeeping-maneuver', {
  mixins: [displayObjectCommon],
  props: {
    isSubMission: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { type: 'leostationkeeping' }
  },

  template: `
  <div>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['perturbations']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['numberOfManeuvers']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['targetMissionDuration']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['attitudeAndSystemSimulated']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['maneuverFrequency']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['smaTopMargin']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['smaBottomMargin']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['alongTrackTolerance']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['customSolarFlux']"/>
  </div>
   `
})

Vue.component('exo-simu-display-SpacecraftDesignAnalysis-maneuver', {
  mixins: [displayObjectCommon],
  props: {
    isSubMission: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { type: 'SpacecraftDesignAnalysis' }
  },

  template: `
  <div>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['restModeMeanPower']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['restModeThrusterPowerRatio']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['thrustModeMeanPower']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['thrustModeThrusterPowerRatio']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['maxThrustDurationWithFullBattery']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['maxAverageThrustDurationPerOrbit']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['restModePercentChargePerOrbit']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['restModePercentChargeOfDODPerOrbit']"/>
  </div>
   `
})

Vue.component('exo-simu-display-strategies-card', {
  mixins: [displayObjectCommon],
  props: {
    isSubMission: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { type: 'strategies' }
  },

  template: `
  <exo-simu-display-card label="Strategies" colorIndex="10" :expand="false">
    <v-col v-for="(strategiesGroup, index) in results.strategiesGroups" :key="index">
      <strategy-card :strategyGroup="strategiesGroup" :index="index"/>
    </v-col>
  </exo-simu-display-card>
   `
})

Vue.component('exo-simu-display-raan-maneuver', {
  mixins: [displayObjectCommon],
  props: {
    isSubMission: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { type: 'raanPhasing' }
  },

  template: `
  <div>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['optimizationType']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['missionDuration']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['coastingDuration']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['coastingSemiMajorAxis']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['coastingAltitude']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['coastingInclination']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['deltaRaanRealized']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['deltaLtanRealized']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['deltaInclination']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['deltaSemiMajorAxis']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['targetDeltaRaan']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['targetDeltaLtan']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['targetDeltaVmax']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['targetMissionDuration']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['minCoastingAltitude']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['maxCoastingAltitude']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['minCoastingInclination']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['maxCoastingInclination']"/>

    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['numberOfStationKeepingManeuvers']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['smaTolerance']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['stationKeepingManeuversFrequency']"/>

    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['perturbations']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['attitudeAndSystemSimulated']"/>

  </div>
   `
})

Vue.component('exo-simu-display-aolphasing-maneuver', {
  mixins: [displayObjectCommon],
  props: {
    isSubMission: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { type: 'aolPhasing' }
  },

  template: `
  <div>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['missionDuration']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['coastingDuration']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['deltaArgumentOfLatitudeRealized']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['targetDeltaArgumentOfLatitude']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['targetDeltaVmax']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['targetMissionDurationForAol']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['perturbations']"/>
    <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['attitudeAndSystemSimulated']"/>
  </div>
   `
})

Vue.component('exo-simu-display-mission-summary-card', {
  mixins: [displayObjectCommon],

  template: `
  <exo-simu-display-card :label="label">
    <exo-simu-display-mission-summary-fields :missionManager="missionManager" :results="results" :path="path"/>
  </exo-simu-display-card>
    `
})

Vue.component('exo-simu-display-mission-summary-fields', {
  mixins: [displayObjectCommon],

  template: `
  <div>
        <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['totalDeltaV']"/>
        <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['totalConsumption']"/>
        <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['simulationDuration']"/>
        <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['totalImpulse']"/>
        <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['averageThrustDuration']"/>
        <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['thrusterDutyCycle']"/>
        <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['finalDutyCycle']"/>        
        <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['totalBurnsDuration']"/>
        <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['totalNumberOfBurns']"/>
        <exo-simu-display-field :additionalData="additionalData" :missionManager="missionManager" :results="results" :path="path" :field="['totalWarmupDutyCycle']"/>
  </div>
  `,

  data() {
    return { type: '' }
  }
})

export default {
  name: 'numericalResultDisplay',

  props: {
    missionManager: Object,
    results: Object,
    additionalData: {
      type: Object,
      default: null
    }
  },

  computed: {
    isEphemerides() {
      return this.results && this.results.ephemerides
    }
  }
}
</script>
